import Module from '../utils/Module';
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class IndustryModule extends Module {
  constructor (options) {
    super(options);

    this.DOMEl = this.options.element;

    this.articlesCards = this.DOMEl.querySelectorAll(".article-card");

    this.init();
  }

  init () {
    this.articlesCards.forEach(card => {
      card.addEventListener('click', () => {
        this.trackArticleClick(card);
      });
    });
  }

  trackArticleClick(articleCard) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "news interaction",
        "action": articleCard.querySelector('.article-title').innerHTML.trim(),
        "label": window.location.href
      }
    });
  }
}
